import logo from "../../Images/brand/logo.png"
import compoundImg from "../../Images/virtuous_database_search.png"
import plantImg from "../../Images/details/4.png"

import { Link } from "react-router-dom";


function Kiwi(){
    return <div className="flex flex-col h-full antialiased bg-neutral-800"> 
    {/* Top Bar */}
    <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
      <div className="flex flex-col items-center justify-between gap-4 p-5 md:flex-row">
        <a href="/"><img className="w-40" src={logo} alt="Virtuous LOGO" /></a>
        <a href="/" className="flex items-center gap-4 cta cta-primary">
          <p>All tools</p>
          <i className="ph-caret-right"></i>
        </a>
      </div>
    </header>
     
        
    
        <main
            className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-10 card">
            {/*Action Top*/}
            <div className="flex items-center gap-4">
                <img src={compoundImg} alt="Virtuous Compounds"
                    className="w-40 h-40 p-4 bg-gray-100 rounded-full" />
                <div>
                    <h1 className="font-bold uppercase ">Virtuous Database Search</h1>
                    <p className="text-gray-500">Dynamic and interactive exploration of the FooDB (<a href="https://foodb.ca"
                            className="link" target="_blank">foodb.ca</a>)</p>
                </div>
            </div>
            
            <div className="flex flex-col gap-4 md:flex-row md:justify-between">
                {/*sx*/}
                <div className="flex items-center justify-center gap-4 p-2 bg-gray-100 rounded-xl">
                    <h1 className="text-xl font-bold uppercase">Kiwi</h1>
                    <div className="flex items-center justify-center gap-2 p-2 bg-white rounded-xl">ID<span
                            className="font-bold ">04</span></div>
                </div>
    
                {/*sx*/}
                <Link to="/foods" className="flex items-center gap-4 cta cta-secondary">
                    <p>Foods list</p>
                    <i className="ph-caret-right"></i>
                </Link>
                
            </div>
    
            {/* info */}
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                
                
                <div className="p-4 bg-gray-100 rounded-xl">
                    <img className="w-full overflow-hidden rounded-xl" src={plantImg} alt="Angelica keiskei" />
                </div>
                <div className="p-4 bg-gray-100 rounded-xl ">
                    <h3 className="mb-3 font-bold">Food description</h3>
                    The kiwifruit, often shortened to kiwi in many parts of the world, is the edible berry of a woody vine in the genus
                    Actinidia. The most common cultivar group of kiwifruit ('Hayward') is oval, about the size of a large hen's egg (5?8
                    centimetres in length and 4.5?5.5 centimetres in diameter). It has a fibrous, dull greenish-brown skin and bright green
                    or golden flesh with rows of tiny, black, edible seeds. The fruit has a soft texture and a sweet but unique flavor, and
                    today is a commercial crop in several countries, such as Italy, New Zealand, Chile, Greece and France.
                </div>
                <div className="grid grid-cols-2 gap-4 p-4 bg-gray-100 md:col-span-2 rounded-xl lg:col-span-1">
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">name <br /><span
                            className="text-xl font-bold">Kiwi</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Scientific name <br /><span
                            className="text-xl font-bold">Actinidia chinensis</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Food group <br /><span
                            className="text-xl font-bold">Fruits</span></div>
                    <div className="items-center justify-center w-full p-4 text-lg bg-white rounded-xl">Food subgroup<br /><span
                            className="text-xl font-bold">Tropical fruits</span></div>
                </div>
                
            </div>
    
    
            {/*Compounds*/}
            <div className="grid gap-4 p-4 bg-gray-100 rounded-3xl ">
            <h3 className="font-bold">Compounds</h3>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left text-primary-100 dark:text-primary-100">
                    <thead className="text-xs text-white uppercase bg-primary-600 dark:text-white">
                        <tr>
                            <th scope="col" className="px-6 py-3"> Name </th>
                            <th scope="col" className="px-6 py-3"> SMILES </th>
                            <th scope="col" className="px-6 py-3"> Content </th>
                            <th scope="col" className="px-6 py-3 text-right"></th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-white">
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">5-p-Coumaroylquinic acid </span><br />C16H18O8 </td>
                            <td className="px-6 py-4"> O[C@@H]1C[C@](O)(C[C@@H](OC(=O)\C=C\C2=CC=C(O)C=C2)[C@@H]1O)C(O)=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"></td>
                            
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"O[C@@H]1C[C@](O)(C[C@@H](OC(=O)\C=C\C2=CC=C(O)C=C2)[C@@H]1O)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">3,4-Dihydroxyphenylacetic acid </span><br />C8H8O4 </td>
                            <td className="px-6 py-4"> OC(=O)CC1=CC(O)=C(O)C=C1</td>
                            <td className="px-6 py-4 whitespace-nowrap"> </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"OC(=O)CC1=CC(O)=C(O)C=C1"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">Moupinamide </span><br />C18H19NO4 </td>
                            <td className="px-6 py-4"> COC1=CC(\C=C\C(=O)NCCC2=CC=C(O)C=C2)=CC=C1O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"COC1=CC(\C=C\C(=O)NCCC2=CC=C(O)C=C2)=CC=C1O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">Tyramine </span><br />C8H11NO </td>
                            <td className="px-6 py-4"> NCCC1=CC=C(O)C=C1 </td>
                            <td className="px-6 py-4"> </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NCCC1=CC=C(O)C=C1"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">2'-Hydroxydaidzein </span><br />C15H10O5 </td>
                            <td className="px-6 py-4"> OC1=CC(O)=C(C=C1)C1=COC2=C(C=CC(O)=C2)C1=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"OC1=CC(O)=C(C=C1)C1=COC2=C(C=CC(O)=C2)C1=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">L-Tyrosine </span><br />C9H11NO3 </td>
                            <td className="px-6 py-4"> NC(CC1=CC=C(O)C=C1)C(O)=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> <span className="font-bold">Orig:</span> 29.00 mg/100g <br /><span className="font-bold">Stand:</span>
                                29.00 mg/100g </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CC1=CC=C(O)C=C1)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">L-Tyrosine </span><br />C9H11NO3 </td>
                            <td className="px-6 py-4"> NC(CC1=CC=C(O)C=C1)C(O)=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> <span className="font-bold">Orig:</span> 34.00 mg/100g <br /><span className="font-bold">Stand:</span>
                                34.00 mg/100g </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CC1=CC=C(O)C=C1)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">L-Tyrosine </span><br />C9H11NO3 </td>
                            <td className="px-6 py-4"> NC(CC1=CC=C(O)C=C1)C(O)=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> <span className="font-bold">Orig:</span> 23.00 mg/100g <br /><span className="font-bold">Stand:</span>
                                23.00 mg/100g </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CC1=CC=C(O)C=C1)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">L-Tyrosine </span><br />C9H11NO3 </td>
                            <td className="px-6 py-4"> NC(CC1=CC=C(O)C=C1)C(O)=O </td>
                            <td className="px-6 py-4 whitespace-nowrap"> <span className="font-bold">Orig:</span> 29.00 mg/100 g <br /><span className="font-bold">Stand:</span>
                                29.00 mg/100 g </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"NC(CC1=CC=C(O)C=C1)C(O)=O"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>
                        <tr className="border-b bg-primary-500 border-primary-400">
                            <td className="px-6 py-4 whitespace-nowrap "> <span className="font-bold">Theobromine </span><br />C7H8N4O2 </td>
                            <td className="px-6 py-4"> CN1C=NC2=C1C(=O)NC(=O)N2C </td>
                            <td className="px-6 py-4 whitespace-nowrap"> <span className="font-bold">Orig:</span> 0.00 mg/100g <br /><span className="font-bold">Stand:</span>
                                0.00 mg/100g </td>
                            <td className="px-6 py-4 text-right whitespace-nowrap">
                            <Link className="px-4 py-2 text-sm font-medium text-primary-900 hover:bg-white hover:text-primary-600 bg-white/40 ring-1 ring-white rounded-xl animation-smooth" 
                                    to="/virtual-taste" state={"CN1C=NC2=C1C(=O)NC(=O)N2C"}>
                                        Virtual taste
                                    </Link>
                            </td>
                        </tr>

                       
                    </tbody>
                </table>
            </div>
        </div>
            {/*Action bottom*/}
            <div className="mx-auto">
                <nav aria-label="Page navigation example">
                    <ul className="inline-flex -space-x-px">
                        <li>
                            <a href="#"
                                className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700">Previous</a>
                        </li>
                        <li>
                            <a href="#" aria-current="page"
                                className="px-3 py-2 leading-tight border border-gray-300 text-primary-600 bg-primary-50 hover:bg-gray-100 hover:text-gray-700">1</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">2</a>
                        </li>
                        <li>
                            <a href="#" 
                                className="px-3 py-2 text-gray-500 bg-white border border-gray-300 hover:bg-primary-100 hover:text-primary-700">3</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">4</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700">5</a>
                        </li>
                        <li>
                            <a href="#"
                                className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </main> 

     
    </div>
}

export default Kiwi;